import {
  Header,
  HeaderItem,
  Sidebar,
  SidebarFooter,
  SidebarItem,
  SidebarPageWrapper,
} from '@trueprodigy/components';
import * as _ from 'lodash';
import ImmutableProptypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';

import * as globalActions from '@actions/global';
import HeaderZendeskWidget from '@components/HeaderZendeskWidget/HeaderZendeskWidget';
import rocketIcon from '@components/Sidebar/assets/rocket-icon.png';
import mraLogo from '@modules/mra/assets/true-prodigy-logo-MRA.png';
import SearchIcon from '@modules/mra/assets/search-icon.png';

import SidebarAccountSettingsWidget from '@components/Sidebar/SidebarAccountSettingsWidget';
import SidebarCaseSettingWidget from '@components/Sidebar/SidebarCaseSettingWidget';
import SidebarRdsNameWidget from '@components/Sidebar/SidebarRdsNameWidget';
import { isSidebarVisibleSelector } from '@selectors/global';
import { modelsSelector } from '@modules/mra/selectors/mra';

import { MraRoute } from '../routes';

const getModelId = model => _.toPairs(model.toJS().data)[0][0];
const isModelSelected = model =>
  !_.isNil(model.toJS().data) && !_.isEmpty(model.toJS().data);

const PageWrapper = ({ isSidebarVisible, toggleSidebar, children, model }) => (
  <div>
    <Helmet>
      <title>MRA</title>
    </Helmet>
    <Sidebar
      isOpen={isSidebarVisible}
      logo={mraLogo}
      sidebarFooter={
        <SidebarFooter>
          <SidebarRdsNameWidget />
          <SidebarCaseSettingWidget />
          <SidebarAccountSettingsWidget />
        </SidebarFooter>
      }
    >
      <SidebarItem icon={rocketIcon} link="/" title="Prodigy App Launcher" />
      <SidebarItem title="Prodigy MRA" nested isOpen>
        <SidebarItem title="Models" link={MraRoute.Models} />
        {isModelSelected(model) ? (
          <SidebarItem title="Model" link={`/mra/model/${getModelId(model)}`} />
        ) : (
          <div />
        )}
        <SidebarItem title="Settings" link={MraRoute.Settings} />
      </SidebarItem>
    </Sidebar>
    <PageWrapper.ContentWrapper>
      <SidebarPageWrapper isSidebarVisible={isSidebarVisible}>
        <Header title="True Prodigy CAD" toggleSidebar={toggleSidebar}>
          <HeaderItem icon={SearchIcon} title="Search" />
          <HeaderZendeskWidget />
        </Header>

        <div>{children}</div>
      </SidebarPageWrapper>
    </PageWrapper.ContentWrapper>
  </div>
);

PageWrapper.propTypes = {
  children: PropTypes.node,
  toggleSidebar: PropTypes.func.isRequired,
  isSidebarVisible: PropTypes.bool.isRequired,
  model: ImmutableProptypes.map,
};

PageWrapper.ContentWrapper = styled.div`
  > div {
    margin-top: -67px;
    min-height: 100vh;
    background-color: #f2f4f6;
  }
`;

const mapStateToProps = state => ({
  isSidebarVisible: isSidebarVisibleSelector(state),
  model: modelsSelector(state),
});

const mapDispatchToProps = {
  toggleSidebar: globalActions.toggleSidebar,
};

const enhance = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);

export default enhance(PageWrapper);
